import { default as doArticleInfoModel } from './articleInfoModel';
import { default as doCommentModel } from './commentModel';
import { default as doReleaseModel } from './releaseModel';

export const sagaArticleInfoModel = doArticleInfoModel.sagas;
export const sagaCommentModel = doCommentModel.sagas;
export const sagaReleaseModel = doReleaseModel.sagas;
